import type { SendEventParams } from '~/shared/analytix'
import type { PlayerOpenParameters } from './player-open'

import { api } from '@setplex/tria-api'
import { createWatch } from 'effector'
import { SnapshotMap } from '../../general/snapshot-map'
import { playStart } from '../models/play-start-stop'
import { parameters as playerOpenParameters } from './player-open'

const SNAPSHOTS_TO_KEEP = 10
let latestHttpErrorCode = ''

export type PlayStartParameters = SendEventParams.PlayStart & {
  '(playerId)'?: string[] // auxiliary parameter to store players id for internal use, it will not be sent to analytix
}

/**
 * SnapshotMap to store `play_start` event parameters with their history
 */
export const parameters = new SnapshotMap<PlayStartParameters>(
  SNAPSHOTS_TO_KEEP
)

//
// Update parameters
//

function fromPlayerOpenParameters(params: SnapshotMap<PlayerOpenParameters>) {
  parameters
    .update('(playerId)', params.get('(playerId)'))
    .update('contentId', params.get('contentId'))
    .update('contentType', params.get('contentType'))
    .update('contentUrl', params.get('contentUrl'))
    .update('contentName', params.get('contentName'))
    .update('programName', params.get('programName'))
    .update('isContentPaid', params.get('isContentPaid'))
    .commit()
    .notify()
}

function fromPlayerState(snapshot: {
  playerId: string
  currentTime: string
  contentLength: string
  httpErrorCode: string
  contentErrorCode: string
  audioTrackLanguage: string
  subtitlesLanguage: string
  videoQuality: string
  playbackSessionId: string
}) {
  const httpErrorCode = snapshot.httpErrorCode || latestHttpErrorCode
  parameters
    .update('(playerId)', [snapshot.playerId])
    .update('startSecond', snapshot.currentTime)
    .update('contentLength', snapshot.contentLength)
    .update('httpErrorCode', httpErrorCode)
    .update('contentErrorCode', snapshot.contentErrorCode)
    .update('audioTrackLanguage', snapshot.audioTrackLanguage)
    .update('subtitlesLanguage', snapshot.subtitlesLanguage)
    .update('videoQuality', snapshot.videoQuality)
    .update('playbackSessionId', snapshot.playbackSessionId)
    .commit()
    .notify()
}

//
// Updates listeners
//

// on player open parameters update
playerOpenParameters.updates.on(() => {
  fromPlayerOpenParameters(playerOpenParameters)
})

createWatch({
  unit: playStart,
  fn: ({ snapshot }) => {
    fromPlayerState(snapshot)
  },
})

createWatch({
  unit: api.player.$currentPlayerPageUrlError,
  fn: (error) => {
    latestHttpErrorCode = String(error?.errorCode ?? error?.code ?? '')
  },
})
